import FloralProductCard from "../../components/categories/FloralProductCard";
import useCartStore from "../../utils/cartStore";
import { useState } from "react";
import GuidePoster from "../../components/GuidePoster";

const GOUTS = [
  { id: "praline-royal",   label: "Praliné Royal",   image: "/images/gouts_roses/praline-royal.png" },
  { id: "nuit-gourmand",   label: "Nuit Gourmand",   image: "/images/gouts_roses/nuit-gourmand.png" },
  { id: "neige-croquante", label: "Neige Croquante", image: "/images/gouts_roses/neige-croquante.png" },
  { id: "rose-orient",     label: "Rose d'Orient",   image: "/images/gouts_roses/rose-orient.png" },
  { id: "coeur-lait-pistache",          label: "Cœur de Lait Cœur Pistache",       image: "/images/gouts_roses/coeur-lait-pistache.png" },
  { id: "coeur-lait-praline-noisette",  label: "Cœur de Lait Praliné Noisette",    image: "/images/gouts_roses/coeur-lait-praline-noisette.png" },
];

const REPARTITION_VIDE = Object.fromEntries(GOUTS.map((g) => [g.id, 0]));

const EMBALLAGES_BOUQUET = [
  { id: "blanc-noir",      label: "Blanc / Noir",     color: "#FFFFFF", accent: "#1a1a1a" },
  { id: "noir-dore",       label: "Noir / Doré",      color: "#1a1a1a", accent: "#D4AF37" },
  { id: "noir",            label: "Noir",              color: "#1a1a1a", accent: "#1a1a1a" },
  { id: "blanc-dore",      label: "Blanc / Doré",     color: "#FFFFFF", accent: "#D4AF37" },
  { id: "blanc",           label: "Blanc",             color: "#FFFFFF", accent: "#FFFFFF" },
  { id: "rose-dore",       label: "Rose / Doré",      color: "#FFB6C1", accent: "#D4AF37" },
  { id: "mauve-dore",      label: "Mauve / Doré",     color: "#C8A2C8", accent: "#D4AF37" },
  { id: "brun",            label: "Brun",              color: "#6F4E37", accent: "#6F4E37" },
];

const BOUQUET_ELEGANT_MODELES = [
  { id: "bouquet-elegant-7",  label: "7 Roses",  roses: 7,  price: 21 },
  { id: "bouquet-elegant-10", label: "10 Roses", roses: 10, price: 30 },
  { id: "bouquet-elegant-20", label: "20 Roses", roses: 20, price: 60 },
];

const EmballageSelector = ({ options, label, selected, onSelect }) => (
  <div className="mb-4">
    <p className="text-sm font-semibold mb-2 text-gray-700">{label} :</p>
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const isSelected = selected?.id === opt.id;
        return (
          <button
            key={opt.id}
            onClick={() => onSelect(opt)}
            className={`flex items-center gap-2 px-2 py-1 rounded-lg border text-xs transition-all ${
              isSelected
                ? "border-primary ring-2 ring-primary ring-offset-1"
                : "border-gray-200 hover:border-gray-400"
            }`}
          >
            <span className="w-5 h-5 rounded-full flex-shrink-0 border border-gray-200" style={{ background: opt.color }} />
            {opt.accent && opt.accent !== opt.color && (
              <span className="w-2 h-2 rounded-full flex-shrink-0 -ml-1" style={{ background: opt.accent }} />
            )}
            <span className="text-gray-700">{opt.label}</span>
          </button>
        );
      })}
    </div>
    {!selected && <p className="text-xs text-amber-600 mt-1">Veuillez choisir</p>}
  </div>
);

const BouquetElegantCard = () => {
  const addToCart = useCartStore((state) => state.addToCart);
  const [selectedModele, setSelectedModele] = useState(BOUQUET_ELEGANT_MODELES[0]);
  const [quantity, setQuantity] = useState(1);
  const [repartition, setRepartition] = useState({ ...REPARTITION_VIDE });
  const [emballage, setEmballage] = useState(null);
  const [demandeParticuliere, setDemandeParticuliere] = useState("");

  const maxRoses = selectedModele.roses;
  const totalRoses = Object.values(repartition).reduce((a, b) => a + b, 0);
  const restant = maxRoses - totalRoses;
  const rosesPret = totalRoses === maxRoses;
  const pret = rosesPret && emballage !== null;

  const handleSelectModele = (modele) => {
    setSelectedModele(modele);
    setRepartition({ ...REPARTITION_VIDE });
  };

  const handleIncrease = (goutId) => {
    if (restant <= 0) return;
    setRepartition((prev) => ({ ...prev, [goutId]: prev[goutId] + 1 }));
  };

  const handleDecrease = (goutId) => {
    if (repartition[goutId] <= 0) return;
    setRepartition((prev) => ({ ...prev, [goutId]: prev[goutId] - 1 }));
  };

 const buildDescription = () => {
  const roses = GOUTS.filter((g) => repartition[g.id] > 0)
    .map((g) => `${repartition[g.id]}x ${g.label}`)
    .join(", ");
  const emb = emballage ? `\nEmballage : ${emballage.label}` : "";
  const demande = demandeParticuliere.trim()
    ? `\nDemande : ${demandeParticuliere.trim()}`
    : "";
  return roses + emb + demande;
};

  const handleAddToCart = () => {
    if (!pret) return;
    addToCart(
      {
        id: selectedModele.id,
        name: `Bouquet Élégant — ${selectedModele.label}`,
        price: selectedModele.price,
        image: "/images/fleurs/bouquet-elegant.jpg",
        category: "Créations Florales",
        description: buildDescription(),
      },
      quantity
    );
    setRepartition({ ...REPARTITION_VIDE });
    setEmballage(null);
    setDemandeParticuliere("");
    setQuantity(1);
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <img src="/images/fleurs/bouquet-elegant.jpg" alt="Bouquet Élégant" className="w-full h-56 object-cover rounded-xl mb-4" />
      <h2 className="text-xl font-semibold mb-2">Bouquet Élégant</h2>

      {/* Modèle */}
      <div className="flex gap-2 mb-3">
        {BOUQUET_ELEGANT_MODELES.map((modele) => (
          <button key={modele.id} onClick={() => handleSelectModele(modele)}
            className={`flex-1 py-1 px-2 rounded-lg text-sm border transition-colors duration-200 ${
              selectedModele.id === modele.id
                ? "bg-primary text-white border-primary"
                : "border-gray-300 text-gray-600 hover:border-primary"
            }`}>
            {modele.label}
          </button>
        ))}
      </div>

      <p className="text-lg font-bold mb-4">{selectedModele.price} €</p>

      {/* Goûts */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">Choisissez vos {maxRoses} roses :</p>
        <GuidePoster image="/images/guides/guide-gouts.jpg" label="Voir le guide des goûts" />
        <div className={`text-xs font-medium mb-3 px-3 py-1 rounded-full inline-block ${
          rosesPret ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"
        }`}>
          {rosesPret ? "✓ Sélection complète !" : `${restant} rose${restant > 1 ? "s" : ""} restante${restant > 1 ? "s" : ""}`}
        </div>
        <div className="space-y-2">
          {GOUTS.map((gout) => {
            const count = repartition[gout.id];
            const canAdd = restant > 0;
            return (
              <div key={gout.id} className="flex items-center gap-3">
                <img src={gout.image} alt={gout.label} className="w-10 h-10 rounded-lg object-cover flex-shrink-0" />
                <span className="text-sm text-gray-700 flex-1">{gout.label}</span>
                <div className="flex items-center gap-2">
                  <button onClick={() => handleDecrease(gout.id)} disabled={count === 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${count === 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>−</button>
                  <span className="w-5 text-center text-sm font-semibold">{count}</span>
                  <button onClick={() => handleIncrease(gout.id)} disabled={!canAdd}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${!canAdd ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>+</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Emballage */}
      <EmballageSelector options={EMBALLAGES_BOUQUET} label="Couleur d'emballage" selected={emballage} onSelect={setEmballage} />

      {/* Demande particulière */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">
          Demande particulière <span className="text-gray-400 font-normal">(optionnel)</span> :
        </p>
        <GuidePoster image="/images/guides/guide-toppers.jpg" label="Voir des exemples de toppers" />
        <input
          type="text"
          value={demandeParticuliere}
          onChange={(e) => setDemandeParticuliere(e.target.value)}
          placeholder="Ex : topper anniversaire, bébé garçon, prénom..."
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
      </div>

      {/* Quantité */}
      <div className="flex items-center gap-3 mb-4">
        <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="w-8 h-8 border rounded">−</button>
        <span>{quantity}</span>
        <button onClick={() => setQuantity(quantity + 1)} className="w-8 h-8 border rounded">+</button>
      </div>

      <button onClick={handleAddToCart} disabled={!pret}
        className={`w-full py-2 rounded-xl font-semibold transition-colors ${pret ? "btn-primary cursor-pointer" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}>
        {!rosesPret ? "Complétez votre sélection" : !emballage ? "Choisissez un emballage" : "Ajouter au panier"}
      </button>
    </div>
  );
};

const CreationsFlorales = () => {
  const products = [
    {
      id: "bouquet-royal",
      name: "Bouquet Royal",
      price: 28,
      roses: 8,
      hasPivoine: true,
      description: "Contient 8 Roses + 1 Fleur Pivoine",
      image: "/images/fleurs/bouquet-royal.jpg",
      emballageType: "bouquet",
      emballageOptions: EMBALLAGES_BOUQUET,
    },
    {
      id: "sac-fleuri",
      name: "Sac fleuri",
      price: 36,
      roses: 12,
      hasPivoine: false,
      description: "Contient 12 Roses",
      image: "/images/fleurs/sac-fleuri.jpg",
      emballageType: "sac",
      emballageOptions: [
        { id: "blanc", label: "Blanc", color: "#FFFFFF" },
        { id: "rose",  label: "Rose",  color: "#F4A7B9" },
        { id: "noir",  label: "Noir",  color: "#1a1a1a" },
      ],
    },
    {
      id: "jardin-gourmand",
      name: "Jardin gourmand",
      price: 32,
      roses: 8,
      hasPivoine: true,
      description: "Contient 8 Roses + 1 Fleur Pivoine",
      image: "/images/fleurs/jardin-gourmand.jpg",
      emballageType: "boite",
      emballageOptions: [
        { id: "blanc", label: "Blanc", color: "#FFFFFF" },
        { id: "noir",  label: "Noir",  color: "#1a1a1a" },
        { id: "rose",  label: "Rose",  color: "#F4A7B9" },
      ],
    },
  ];

  return (
    <div className="section-padding">
      <h1 className="text-4xl font-bold mb-12">Nos Créations Florales</h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        <FloralProductCard key={products[0].id} product={products[0]} />
        <BouquetElegantCard />
        {products.slice(1).map((product) => (
          <FloralProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default CreationsFlorales;